import React from "react";

export default function PillIcon() {
  return (
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.979 10.9792L17.4373 4.52088C18.0288 3.91732 18.7341 3.437 19.5123 3.1077C20.2906 2.77839 21.1264 2.60664 21.9715 2.60238C22.8166 2.59811 23.6541 2.76141 24.4357 3.08283C25.2172 3.40425 25.9273 3.87742 26.5249 4.47498C27.1224 5.07254 27.5956 5.78263 27.917 6.56419C28.2384 7.34575 28.4017 8.18327 28.3975 9.02834C28.3932 9.8734 28.2215 10.7092 27.8921 11.4875C27.5628 12.2658 27.0825 12.9711 26.479 13.5625L20.0206 20.0209M10.979 10.9792L4.52063 17.4375C3.91707 18.029 3.43675 18.7343 3.10745 19.5126C2.77815 20.2909 2.6064 21.1267 2.60213 21.9718C2.59786 22.8168 2.76116 23.6543 3.08259 24.4359C3.40401 25.2175 3.87718 25.9276 4.47474 26.5251C5.07229 27.1227 5.78238 27.5958 6.56394 27.9173C7.3455 28.2387 8.18303 28.402 9.02809 28.3977C9.87316 28.3934 10.709 28.2217 11.4873 27.8924C12.2655 27.5631 12.9708 27.0828 13.5623 26.4792L20.0206 20.0209M10.979 10.9792L15.4998 15.5L20.0206 20.0209"
        stroke="#4C8395"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
